import { AppbarConnectorService } from '@office-start/appbar-connector-service';
import { logCopilotFunnelEvent } from '@office-start/copilot-fre-telemetry-service';
import { getHwaPageReloadCount } from '@office-start/hwa-native-bridge-service';
import { copilotM365AppId } from '@office-start/m365-apps-service';
import { handlePauseScheduling, handleResumeScheduling, } from '@office-start/scheduler-service';
import { logMosHubErrorAndFeature } from '../utils';
export const appbarConnectorService = AppbarConnectorService.getInstance();
export class AppHostTelemetryService {
    constructor(appHostSessionId, frameContext, isTileChanged, appUrl, isStandaloneCopilotApp) {
        this.logTelemetryEvent = (name, appId, clientTimestamp, error, pagePrefetchTime, pagePrefetchRedirectionCount) => {
            var _a, _b;
            const messageReceivedTimeStamp = new Date().getTime();
            if (window.Windows) {
                name = `HwaReload_${getHwaPageReloadCount()}.${name}`;
            }
            const info = {
                appHostSessionId: this._appHostSessionId,
                appId: appId,
                clientTimestamp: clientTimestamp,
                error: error,
                frameContext: this._frameContext,
                messageDelayMs: clientTimestamp
                    ? messageReceivedTimeStamp - clientTimestamp
                    : 0,
                scenarioName: name,
                isTileChange: this._isTileChanged,
                appUrl: this._appUrl,
                pagePrefetchTime: pagePrefetchTime !== null && pagePrefetchTime !== void 0 ? pagePrefetchTime : 0,
                pageTimeLoadSinceDocumentRenderStarts: (_a = appbarConnectorService.timeElapsedSinceDocuementRender) !== null && _a !== void 0 ? _a : 0,
                pagePrefetchRedirectionCount: pagePrefetchRedirectionCount !== null && pagePrefetchRedirectionCount !== void 0 ? pagePrefetchRedirectionCount : 0,
                isStandaloneCopilotApp: (_b = this._isStandaloneCopilotApp) !== null && _b !== void 0 ? _b : false,
                resourceDeliveryType: appbarConnectorService.resourceDeliveryType,
            };
            logMosHubErrorAndFeature(info);
        };
        this._appHostSessionId = appHostSessionId;
        this._frameContext = frameContext;
        this._isTileChanged = isTileChanged !== null && isTileChanged !== void 0 ? isTileChanged : false;
        this._appUrl = appUrl !== null && appUrl !== void 0 ? appUrl : '';
        this._isStandaloneCopilotApp = isStandaloneCopilotApp !== null && isStandaloneCopilotApp !== void 0 ? isStandaloneCopilotApp : false;
    }
    createScenario(name, appId, clientTimestamp) {
        return new TelemetryScenario(name, appId, this.logTelemetryEvent, clientTimestamp);
    }
}
class TelemetryScenario {
    constructor(scenarioName, appId, logTelemetryEventCallback, clientTimestamp, stageCEndTime) {
        this.scenarioName = scenarioName;
        this.appId = appId;
        this.logTelemetryEventCallback = logTelemetryEventCallback;
        this.clientTimestamp = clientTimestamp;
        this.stageCEndTime = stageCEndTime;
        this.appInitializationScenario = 'appInitialization';
        this.appTerminationScenario = 'appTermination';
        this.clickToBeginLoadScenario = 'ClickToBeginLoad';
        this.isClickToBeginLoadPhase = (phaseName) => phaseName.toString() === this.clickToBeginLoadScenario;
        this.logSchedulerResumedMosHubFeature = (scenarioName) => logMosHubErrorAndFeature({
            appId: this.appId,
            appHostSessionId: '',
            frameContext: '',
            scenarioName: scenarioName,
            clientTimestamp: appbarConnectorService === null || appbarConnectorService === void 0 ? void 0 : appbarConnectorService.userClickTime,
            isTileChange: appbarConnectorService === null || appbarConnectorService === void 0 ? void 0 : appbarConnectorService.tileChanged,
            appUrl: window.location.pathname,
            resourceDeliveryType: appbarConnectorService === null || appbarConnectorService === void 0 ? void 0 : appbarConnectorService.resourceDeliveryType,
        });
        this.markPhase = (phaseName) => {
            this.logTelemetryEventCallback(phaseName.toString(), this.appId, this.clientTimestamp);
            // adding new telemetry for calculating Stage C time
            if (this.isClickToBeginLoadPhase(phaseName)) {
                this.logTelemetryEventCallback(`${phaseName.toString()}Revised`, this.appId, appbarConnectorService.stageBEndTime);
                this.stageCEndTime = Date.now();
            }
            if (this.appId === copilotM365AppId &&
                this.isClickToBeginLoadPhase(phaseName)) {
                logCopilotFunnelEvent('onCopilotAppLoadStart', {
                    ElapsedTime: appbarConnectorService.userClickTime
                        ? `${Date.now() - appbarConnectorService.userClickTime}`
                        : '',
                });
            }
            if (appbarConnectorService.pauseSchedulerForMosApp &&
                this.appId === copilotM365AppId &&
                phaseName === this.clickToBeginLoadScenario) {
                handlePauseScheduling();
            }
        };
        this.stop = () => {
            let pagePrefetchTime = 0;
            let pageRedirectionCount = 0;
            if (!appbarConnectorService.tileChanged) {
                if (typeof performance.getEntriesByType === 'function') {
                    const entries = performance.getEntriesByType('navigation');
                    if (entries &&
                        entries.length > 0 &&
                        entries[0].responseEnd &&
                        entries[0].responseEnd >= 0) {
                        pagePrefetchTime = Math.round(entries[0].responseEnd);
                        pageRedirectionCount = entries[0].redirectCount;
                    }
                }
            }
            this.logTelemetryEventCallback(`stop ${this.scenarioName}`, this.appId, this.clientTimestamp, undefined, pagePrefetchTime, pageRedirectionCount);
            this.logTelemetryEventCallback(`stop${this.scenarioName}Revised`, this.appId, this.stageCEndTime, undefined, pagePrefetchTime, pageRedirectionCount);
            if (this.appId === copilotM365AppId &&
                this.scenarioName === 'appInitialization') {
                logCopilotFunnelEvent('onCopilotAppLoadCompletion', {
                    ElapsedTime: appbarConnectorService.userClickTime
                        ? `${Date.now() - appbarConnectorService.userClickTime}`
                        : '',
                });
            }
            if (this.appId === copilotM365AppId &&
                this.scenarioName === 'appTermination') {
                logCopilotFunnelEvent('onCopilotAppTermination', {});
            }
            if (this.shouldResumeScheduling()) {
                this.logSchedulerResumedMosHubFeature(`CopilotAppLoad${this.scenarioName === 'appTermination'
                    ? 'Termination'
                    : 'Completion'}ResumeScheduling`);
                handleResumeScheduling();
            }
        };
        this.fail = (error) => {
            this.logTelemetryEventCallback(`fail ${this.scenarioName}`, this.appId, this.clientTimestamp, error);
            if (this.appId === copilotM365AppId &&
                this.scenarioName === 'appInitialization') {
                logCopilotFunnelEvent('onCopilotAppLoadFailure', {
                    MosAppError: error !== null && error !== void 0 ? error : '',
                    ElapsedTime: appbarConnectorService.userClickTime
                        ? `${Date.now() - appbarConnectorService.userClickTime}`
                        : '',
                });
            }
            if (this.shouldResumeScheduling()) {
                this.logSchedulerResumedMosHubFeature('CopilotAppLoadFailureResumeScheduling');
                handleResumeScheduling();
            }
        };
        this.logTelemetryEventCallback(scenarioName, appId, clientTimestamp);
    }
    shouldResumeScheduling() {
        var _a, _b;
        return ((_b = ((appbarConnectorService.pauseSchedulerForMosApp ||
            appbarConnectorService.pauseSchedulerInAHCInternal) &&
            this.appId === copilotM365AppId &&
            (this.scenarioName === this.appInitializationScenario ||
                (((_a = appbarConnectorService.appUrl) === null || _a === void 0 ? void 0 : _a.includes('chat')) &&
                    appbarConnectorService.tileChanged &&
                    this.scenarioName === this.appTerminationScenario)))) !== null && _b !== void 0 ? _b : false);
    }
}
//# sourceMappingURL=AppHostTelemetryService.js.map